
export default {
    name: "FaqElement",
    props: {
        blok: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
    },
    methods: {
        getDisplayedIndex(idx) {
            return idx.toString().padStart(2, "0")
        },
    },
}
